/**
 * 拓扑插件-子组件属性全局mixins函数
 */
export default {
  props: {
    tpContext: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tpConfig: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    tpStore: {
      get() {
        return this.tpContext;
      },
      set(val) {
        this.$emit('update:tpContext', val);
      }
    },
    tpOptions: {
      get() {
        return this.tpConfig;
      },
      set(val) {
        this.$emit('update:tpConfig', val);
      }
    }
  }
};
